// usePageTracking.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';

const META_PIXEL_ID = '1016720297551697';

ReactPixel.init(META_PIXEL_ID, {}, { autoConfig: true, debug: false });

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    ReactPixel.pageView();
  }, [location]);
};

export default usePageTracking;
